define('app/editor/dialogs/SetAlertDialogView',['require','./SaveDialogView','app/app','app/config/reportTypes','glu/util','glu/dialog','hbs!./SetAlertDialogView.hbs'],function(require) {
	'use strict';

	var SaveDialogView = require('./SaveDialogView'),
		App = require('app/app'),
		reportTypes = require('app/config/reportTypes'),
		_ = require('glu/util'),
		dialog = require('glu/dialog');

	var view = SaveDialogView.extend({

		dialogTitle: 'Set Email Alert',

		getClass: function() {
			return 'modal-set-alert';
		},

		dialogButtons: [{
			text: 'Set',
			callback: 'send',
			className: 'btn-primary'
		}, {
			text: 'Cancel',
			callback: 'cancelCallback',
			className: 'btn-primary'
		}],

		template: require('hbs!./SetAlertDialogView.hbs'),

		ui: {
			$alertType: '[name="alert-type"]',
			$value: '[name="value"]',
			$value1: '[name="value1"]',
			$value2: '[name="value2"]',
			$sectionOneValue: '#oneValue',
			$sectionTwoValue: '#twoValue',
			$timeUnit: '[name="timeUnit"]',
			$timeUnitMin: '[name="minTimeUnit"]',
			$timeUnitMax: '[name="maxTimeUnit"]',
			$frequency: '[name="frequency"]'
		},

		events: {
			'change [name="alert-type"]': 'toggleInput',
			'change [name="value"]': 'isValidAlert',
			'change [name="value1"]': 'isValidAlert',
			'change [name="value2"]': 'isValidAlert',
			'keyup [name="value"]': 'isValidAlert',
			'keyup [name="value1"]': 'isValidAlert',
			'keyup [name="value2"]': 'isValidAlert',
			'change [name="minTimeUnit"]': 'isValidAlert',
			'change [name="maxTimeUnit"]': 'isValidAlert',
			'change #save-dialog-name': 'onChangeName',
			'keyup #save-dialog-name': 'onChangeName',
			'change #save-dialog-description': 'onChangeDesc',
			'keyup #save-dialog-description': 'onChangeDesc'
		},

		toggleInput: function() {
			var option = this.$el.find(this.ui.$alertType).val();
			if (option === 'LOW' || option === 'HIGH') {
				this.ui.$sectionOneValue.show();
				this.ui.$sectionTwoValue.hide();
			} else {
				this.ui.$sectionOneValue.hide();
				this.ui.$sectionTwoValue.show();
			}
		},

		onRender: function() {
			this.ui.$alertType.comboBox();
			this.ui.$frequency.comboBox();
			this.toggleInput();
		},

		send: function() {
			var payload = {},
				self = this,
				option = this.$el.find(this.ui.$alertType).val();

			if (this.isValid() && self.isValidAlert()) {
				// at this point, a new 'snapshot' report of the current report is created
				self.model.saveAlertReport(self.uigetName(), self.uigetDescription()).then(function(res) {
					payload.reportId = res.id;
					payload.desirable = true;
					payload.range = option;
					payload.isPrivate = true;

					if (option === 'LOW' || option === 'HIGH') {
						payload.value1 = self.$el.find(self.ui.$value).val();
						if (self.isTimespan()) {
							var timeUnit = self.ui.$timeUnit.val();
							payload.value1 = self.convertTimespan(payload.value1, timeUnit);
						}

					} else {
						payload.value1 = self.$el.find(self.ui.$value1).val();
						payload.value2 = self.$el.find(self.ui.$value2).val();
						if (self.isTimespan()) {
							var minTimeUnit = self.ui.$timeUnitMin.val();
							var maxTimeUnit = self.ui.$timeUnitMax.val();
							payload.value1 = self.convertTimespan(payload.value1, minTimeUnit);
							payload.value2 = self.convertTimespan(payload.value2, maxTimeUnit);
						}
					}

					payload.schedule = self.ui.$frequency.val();

					self.model.setAlert(payload).then(function() {
						dialog.close();
						self.model.trigger('alertSet');
						self.navigateTo('/domains/' + self.model.getDomainId() + '/reports/' + res.id);
					});
				});
			}
		},

		isValidAlert: function() {
			var option = this.$el.find(this.ui.$alertType).val();
			if (option === 'LOW' || option === 'HIGH') {
				var value = this.$el.find(this.ui.$value).val();
				if (value === '' || isNaN(value) || value < 0) {
					this.ui.$value.addClass('input-dialog-item-error');
					return false;
				} else {
					this.ui.$value.removeClass('input-dialog-item-error');
					return true;
				}
			} else {
				var value1 = parseFloat(this.$el.find(this.ui.$value1).val());
				var value2 = parseFloat(this.$el.find(this.ui.$value2).val());
				if (this.isTimespan()) {
					// need to check the time values based on the units
					var minTimeUnit = this.ui.$timeUnitMin.val();
					var maxTimeUnit = this.ui.$timeUnitMax.val();
					value1 = this.convertTimespan(value1, minTimeUnit);
					value2 = this.convertTimespan(value2, maxTimeUnit);
				}

				var error = false;
				if (value1 === '' || isNaN(value1) || value1 < 0) {
					this.ui.$value1.addClass('input-dialog-item-error');
					error = true;
				}
				if (value2 === '' || isNaN(value2) || value2 < 0) {
					this.ui.$value2.addClass('input-dialog-item-error');
					error = true;
				}

				if (value1 >= value2) {
					this.ui.$value1.addClass('input-dialog-item-error');
					this.ui.$value2.addClass('input-dialog-item-error');
					error = true;
				}

				if (error) {
					return false;
				} else {
					this.ui.$value1.removeClass('input-dialog-item-error');
					this.ui.$value2.removeClass('input-dialog-item-error');
					return true;
				}
			}

		},

		cancelCallback: function() {
			dialog.close();
		},

		serializeData: function() {
			return this;
		},

		// methods for unit tests
		uiSetOption: function(option) {
			this.$el.find(this.ui.$alertType).val(option);
		},

		uiSetValues: function(value1, value2) {
			var option = this.$el.find(this.ui.$alertType).val();
			if (option === 'LOW' || option === 'HIGH') {
				this.$el.find(this.ui.$value).val(value1);
			} else {
				this.$el.find(this.ui.$value1).val(value1);
				this.$el.find(this.ui.$value2).val(value2);
			}
		},

		isTimespan: function() {
			// check if the selected column is a timespan
			var selectedColumn = this.model.getSelectedColumn();
			if (selectedColumn) {
				var column = this.model.getColumnByName(selectedColumn);
				if (column && column.getAggregation() !== 'COUNT' && column.getAggregation() !== 'COUNTD' && ((column.get('columnType') === 'FUNCTION' && column.get('type') === 'TIMESPAN') ||
						(column.get('fieldObject') && column.get('fieldObject').get('type') === 'TIMESPAN'))) {
					return true;
				}
			}
			return false;
		},

		convertTimespan: function(value, unit) {
			var seconds = 0;
			if (unit === 'minutes') {
				seconds = value * 60;
			} else if (unit === 'hours') {
				seconds = value * 60 * 60;
			} else if (unit === 'days') {
				seconds = value * 24 * 60 * 60;
			}
			return seconds;
		},

		validate: function(val, field) {
			// call base class isValid function
			SaveDialogView.prototype.validate.call(this, val, field);

			if (this.$el.find(this.nameFieldId).parent().hasClass('has-error')) {
				return;
			}

			var desiredName = this.uigetName();
			// check for duplicate name
			// get all report names
			var metric = _.find(App.domains.models, function(domain) {
				return _.find(domain.reportCollection().models, function(r) {
					if (r.isOwner() && r.getReportType() === reportTypes.ALERT &&
						r.getName().trim() === desiredName.trim()) {
						return r;
					}
				});
			});

			if (metric) {
				this.$el.find(this.nameFieldId).parent().addClass('has-error');
				this.$el.find(this.nameFieldId).parent().find('span.help-block').text('Duplicate alert name');
			} else {
				this.$el.find(this.nameFieldId).parent().removeClass('has-error');
				this.$el.find(this.nameFieldId).parent().find('span.help-block').text();
			}
		}

	});

	return view;
});

